export default __webpack_public_path__ + "static/media/AGC_2024_R4_QP_Class_3.31d6cfe0.pdf";